import styled from "styled-components";

export const Select = styled.select`
  width: 100%;
  height: 45px;
  padding: 12px 16px 12px 16px;
  border-radius: 9px;
  background: white;
  box-shadow: 0px 16px 64px rgba(0, 0, 0, 0.04);
  :placeholder {
    color: #d8dce9;
    font-size: 14px;
    line-height: 21px;
  }
`;
